import { Router } from '@angular/router';
import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { select, Store } from '@ngrx/store';

import { TranslateService } from '@ngx-translate/core';

import * as authActions from '@app/modules/authentication/actions/authentication.actions';
import * as authReducer from '@app/modules/authentication/reducers/authentication.reducer';

import { AuthenticationService } from '@app/modules/authentication/services/authentication.service';

import { AuthRoutes } from '@app/shared/routes/routes';

import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';

import { NGXLogger } from 'ngx-logger';

/**
 * Interceptor for handling errors.
 */
@Injectable()
export class ErrorHandlingInterceptor implements HttpInterceptor {
  readonly AUTHORIZATION_HEADER = 'Authorization';
  readonly X_CORRELATION_ID = 'X-Correlation-ID';

  private authService: AuthenticationService;
  private translateService: TranslateService;
  private router: Router;

  constructor(private injector: Injector, private store: Store<any>, private logger: NGXLogger) {
    // what the fuck angular
    setTimeout(() => {
      this.authService = this.injector.get(AuthenticationService);
      this.translateService = this.injector.get(TranslateService);
      this.router = this.injector.get(Router);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((res: HttpErrorResponse) => {
        switch (res.status) {
          case 400:
          case 403:
          case 409:
          case 500:
            if (res.error && res.error.message) {
              const errorMessage = this.translateService.instant(res.error.message);
              this.logger.error(errorMessage);
              // TODO should toast error;

            }
            const correlationId = req.headers.get(this.X_CORRELATION_ID);
            if (correlationId) {
              this.logger.error('Please contact the administrator and use this ID: ' + correlationId);
              const errorMessage =
                this.translateService.instant('error.correlationId', {correlationId});
              // TODO should toast error;
            }
            break;
          case 401:
            this.logger.error('Unauthorized ', res);
            if (res.error && res.error.message) {
              // TODO should toast this.translateService.instant(res.error.message);
              if (res.error.message === 'general.messages.401.invalidToken') {
                this.store.dispatch(authActions.refreshToken());
                return this.store.pipe(select(authReducer.getAuthState),
                  filter(authState => !authState.isLoading && !!authState.authUser),
                  take(1),
                  switchMap(() => {
                    const userToken = localStorage.getItem('user_token');
                    const headers = userToken ? req.headers.set(this.AUTHORIZATION_HEADER, 'Bearer ' + userToken) : req.headers;

                    const clonedRequest = req.clone({
                      headers
                    });

                    return next.handle(clonedRequest);
                  })
                );
              } else if (res.error.message.startsWith('general.messages.401')) {
                if (this.authService.getUserDetails()) {
                  this.store.dispatch(authActions.logout());
                }
              }
            } else {
              this.router.navigate([AuthRoutes.Login.url]).then();
            }
            break;
          case 404:
            this.router.navigate([AuthRoutes.Login.url]).then();
            break;
          default:
            if (res && res.status) {
              return observableThrowError(res);
            }
        }

        return observableThrowError(res);
      })
    );
  }
}
